export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 42 40" className={className} aria-hidden="true">
    <path d="M16 7 L5 13.5 V26.5 L16 33 Z" fill="#8A8F98" />
    <path d="M22 7 L33 13.5 V26.5 L22 33 Z" fill="currentColor" />
    <path d="M16 12 L10 15.5 V24.5 L16 28 Z" fill="#ffffff" opacity="0.9" />
    <rect x="28" y="1" width="5" height="5" rx="1.2" fill="currentColor" transform="rotate(12 30.5 3.5)" />
    <rect x="35" y="5.5" width="3.4" height="3.4" rx="0.9" fill="currentColor" opacity="0.65" transform="rotate(12 36.7 7.2)" />
  </svg>
);

export const Logo = () => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <span className="text-primary">
      <LogoMark className="h-7 w-7 sm:h-8 sm:w-8" />
    </span>
    <span className="font-display font-extrabold uppercase tracking-tight text-base sm:text-lg leading-none">
      <span className="text-[#7C8289] dark:text-white/80">Ground</span>
      <span className="text-primary">breaking</span>
      <span className="text-[#7C8289] dark:text-white/80"> IT</span>
    </span>
  </span>
);
